import { useMemo } from "react"
import { Block, LabelLarge, Mats, useStyletron } from "@mezo-org/mezo-clay"

import MatsDisplayWidget from "#/ui-old/MatsDisplayWidget"

type DepositBoostProps = {
  isActive: boolean
  multiplier: number
  dailyMats: string
  extendBoost?: boolean
}

export default function DepositBoost({
  isActive,
  multiplier,
  dailyMats,
  extendBoost,
}: DepositBoostProps) {
  const [, theme] = useStyletron()

  const textColor = useMemo(
    () => (isActive ? theme.colors.white : theme.colors.black),
    [isActive, theme],
  )

  if (extendBoost) {
    return (
      <MatsDisplayWidget
        mats={dailyMats}
        variant="label"
        size="md"
        color={textColor}
        invertColors={isActive}
        mr={5}
        tooltipWithLightShadow
        tooltipPlacement="left"
      />
    )
  }

  return (
    <Block
      paddingRight={theme.sizing.scale700}
      display="flex"
      alignItems="center"
    >
      <LabelLarge color={textColor} marginRight="scale300">
        {multiplier}x
      </LabelLarge>
      <Mats color={textColor} size={theme.sizing.scale600} />
      <LabelLarge color={textColor}>Boost</LabelLarge>
    </Block>
  )
}
